/**
 * Line height scale, in pixels.
 *
 * These were `typography.lineHeight` in `@moderneinc/design-system-tokens` until the
 * Figma token sync (moderneinc/design-system#662) removed the `line-height`
 * primitives.
 * The values here are the removed primitives verbatim, so rendering is
 * unchanged.
 *
 * `semanticTypography` is not a substitute: it exposes line height per text
 * role (body, button, table, ...) as rem strings, whereas every call site here
 * needs the raw numeric scale — either as `${...}px` or as a unitless ratio
 * (`lineHeight.xl / fontSize.h1`).
 *
 * Remove this once the design system restores the primitives or publishes a numeric
 * replacement, and point the call sites back at the token.
 */
export const lineHeight = {
  xs: 16,
  s: 20,
  m: 24,
  l: 28,
  xl: 32
} as const;
